import type { ComponentType, SVGProps } from 'react';

import { Currency } from '@/shared/types/currency';

import AUFlag from '@/shared/assets/icons/flags/au.svg';
import CAFlag from '@/shared/assets/icons/flags/ca.svg';
import CHFlag from '@/shared/assets/icons/flags/ch.svg';
import EUFlag from '@/shared/assets/icons/flags/eu.svg';
import GBFlag from '@/shared/assets/icons/flags/gb.svg';
import JPFlag from '@/shared/assets/icons/flags/jp.svg';
import NZFlag from '@/shared/assets/icons/flags/nz.svg';
import USFlag from '@/shared/assets/icons/flags/us.svg';

/**
 * Returns the currency symbol for the given currency code
 * @param currency - The currency code from Currency enum
 * @returns The currency symbol as a string, or empty string if currency is not supported
 */
export function getCurrencySymbol(currency: Currency): string {
    switch (currency) {
        case Currency.USD:
            return '$';
        case Currency.EUR:
            return '€';
        case Currency.CAD:
            return '$';
        case Currency.GBP:
            return '£';
        case Currency.AUD:
            return '$';
        case Currency.CHF:
            return '₣';
        default:
            return '';
    }
}

/**
 * Maps currency codes to their corresponding flag SVG components
 * This mapping allows for easy display of currency flags throughout the application
 */
export const currencyFlagMap: Record<
    Currency,
    ComponentType<SVGProps<SVGSVGElement>>
> = {
    [Currency.USD]: USFlag,
    [Currency.EUR]: EUFlag,
    [Currency.CAD]: CAFlag,
    [Currency.AUD]: AUFlag,
    [Currency.CHF]: CHFlag,
    [Currency.GBP]: GBFlag,
    [Currency.JPY]: JPFlag,
    [Currency.NZD]: NZFlag,
};
